import React, { useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Row, Card, Form, Input, Col, Radio, Button, Space, Spin, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero, SEO } from './components'
import {
  getSecurityQuestions,
  checkSecurityQuestions,
  resetPasswordWithTemp,
  retrievePolicyUser,
  checkGWAccount,
  updatePassword,
  verifyLogin,
  getWebsiteMaintenanceStatus
} from '../services'
import { useWindowSize, getDomain } from '../utils'
import Router from "next/router";
import { checkSelfService } from '../services/Api'

import ForgotPassStyle from '../../styles/ForgotPassword.module.css'

const { Text, Link } = Typography
const antIcon = <LoadingOutlined spin style={{ fontSize: 24 }} />

const getEnvSite = () => {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case 'localhost':
        return 'https://getquotestg.cure.com/ServiceInterruption.aspx'
      case 'staging.cure.com':
        return 'https://getquotestg.cure.com/ServiceInterruption.aspx'
      case 'prepublish.cure.com':
        return 'https://getquoteprep.cure.com/ServiceInterruption.aspx'
      default:
        return 'https://getquote.cure.com/ServiceInterruption.aspx'
    }
  }
}

const ForgotPassword = () => {
  const [lastName, setLastName] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [selectedResetOption, setSelectedResetOption] = useState(-1)
  const [selectedPwdOption, setSelectedPwdOption] = useState(-1)
  const [retrievedPolicyUser, setRetrievedPolicyUser] = useState(null)
  const [message, setMessage] = useState(null)
  const [tempPasswordMsg, setTmpPasswordMsg] = useState(null)
  const [securityAnswer, setSecurityAnswer] = useState(null)
  const [filteredSecurityQuestions, setFilteredSecurityQuestions] = useState(null)
  const [changePassword, setChangePassword] = useState(null)
  const [newPassword, setNewPassword] = useState('')
  const [retypePassword, setRetypePassword] = useState('')
  const [passwordResetMessage, setPasswordResetMessage] = useState(null)
  const [securityQuestionMessage, setSecurityQuestionMessage] = useState(null)
  const [showLogin, setShowLogin] = useState(null)
  const [loginApiResponseMessage, setLoginApiResponseMessage] = useState()
  const [password, setPassword] = useState('')
  const [showSpinner, setShowSpinner] = useState(false)

  const windowSize = useWindowSize()
  const isMobile = windowSize.width > 1024
  const handleSubmit = async () => {
    setMessage(null)
    setShowSpinner(true)
    const response = await retrievePolicyUser(lastName, dateOfBirth, zipCode, 'forgot-password')
    if (response && response.data && response.data.Result === 'Success') { //user found in tblPolicyUsers

      // Check self service table if policy is blocked from logging in
      const selfServiceResponse = await checkSelfService(response?.data?.User?.Policy_Number, response?.data?.User?.Env)
      if (selfServiceResponse?.data?.Result != null) {
        setMessage(selfServiceResponse?.data?.Result)
        setShowSpinner(false)
      }
      else {
        setRetrievedPolicyUser(response.data)
        setMessage(response.data.Result)
      }
    }
    else if (response && response.data && response.data.Result === "Error") { //some error
      setMessage("An error occured")
    }
    else if (response && response.data && response.data.Result === "Inactive") { //some error
      setMessage(response.data.Result)
    }
    else if (response && response.data && response.data.Result !== 'Success') { //user not found in tblPolicyUsers, check GW table
      const res = await checkGWAccount({ LastName: lastName, DOB: dateOfBirth })
      if (res && res.data && res.data.Result === 'Success') {

        // Check self service table if policy is blocked from logging in
        const selfServiceResponse = await checkSelfService(res?.data?.Account?.Policy_Number, res?.data?.Account?.Env)
        if (selfServiceResponse?.data?.Result != null) {
          setMessage(selfServiceResponse?.data?.Result)
          setShowSpinner(false)
        }
        else {
          if (res.data.Account.IsRegistered === false) {
            if (res.data.Account.GWUserID) {
              Router.push(`/my-account/update?verifiedUser=${res.data.Account.GWUserID}`);
            }
            else {
              Router.push(`/my-account/update?verifiedUser=${res.data.Account.EmailAddress}`);
            }
          }
        }
      }
      else if (res && res.data && res.data.Result === "Error") { //some error
        setMessage("An error occured")
      }
      else if (res && res.data && res.data.Result !== 'Success') {
        setMessage(res.data.Result);
      }
    }
    setShowSpinner(false)
  }

  const handleRadioButtonClick = event => {
    setTmpPasswordMsg('')
    setSelectedPwdOption(-1)
    setSelectedResetOption(event.target.value)
  }

  useEffect(() => {
    async function fetchWebsiteMaintainence() {
      const websiteStatusResponse = await getWebsiteMaintenanceStatus()
      if (websiteStatusResponse && websiteStatusResponse.data) {
        const status = websiteStatusResponse.data
        if (
          status.Result == "Active" && status?.Pages.includes("MyAccountLogin")
          && !status.AllowAccessPages.includes("MyAccountLogin")
        ) {
          window.location.href = getEnvSite()
        }
      }
    }
    fetchWebsiteMaintainence()

    async function fetchSecurityQuestions() {
      const securityQuestions = await getSecurityQuestions()
      if (retrievedPolicyUser && securityQuestions.data) {
        const questions = securityQuestions.data.filter(({ Code }) => {
          return (
            retrievedPolicyUser.User.SecurityQuestion1 === Code ||
            retrievedPolicyUser.User.SecurityQuestion2 === Code ||
            retrievedPolicyUser.User.SecurityQuestion3 === Code
          )
        })
        setFilteredSecurityQuestions(questions)
      }
    }
    if (retrievedPolicyUser) {
      fetchSecurityQuestions()
    }
  }, [retrievedPolicyUser])

  const handleZipCodeChange = event => {
    const value = event.target.value.replace(/\D/g, '')
    setZipCode(value)
  }

  const handleRadioClick = event => {
    const selectedSecurityQuestion = event.target.value
    setSelectedPwdOption(selectedSecurityQuestion)
  }

  const validateUser = async () => {
    setShowSpinner(true)
    setTmpPasswordMsg('')
    if (selectedPwdOption) {
      if (selectedPwdOption === -1 && selectedResetOption === 1) {
        await resetPasswordWithTemp({
          PolicyNumber: retrievedPolicyUser.User.Policy_Number,
          ZipCode: retrievedPolicyUser.User.Zip,
          EmailAddress: retrievedPolicyUser.User.EmailAddress,
          Env: retrievedPolicyUser.User.Env
        })
        setTmpPasswordMsg('An email with your temporary password has been sent.')
      } else if (selectedResetOption === 2 && selectedPwdOption !== -1) {
        const securityQuestionList = filteredSecurityQuestions.map(question => ({
          Code: question.Code,
          Answer: question.Code === selectedPwdOption ? securityAnswer : ''
        }))

        const response = await checkSecurityQuestions({
          PolicyNumber: retrievedPolicyUser.User.Policy_Number,
          ZipCode: retrievedPolicyUser.User.Zip,
          Questions: securityQuestionList
        })
        const isValid = response.data.Questions.filter(question => question.Match === true)

        if (isValid && isValid.length > 0) {
          setChangePassword(true)
        } else {
          setSecurityQuestionMessage('Invalid Answer. Try again.')
        }
      }
    }
    setShowSpinner(false)
  }

  const validateUserPassword = (newPassword, retypePassword) => {
    let response = true
    if (newPassword !== retypePassword) {
      response = false
    }
    return response
  }

  const handleUpdatePassword = async () => {
    setShowSpinner(true)
    setShowLogin(false)
    const validationResponse = validateUserPassword(newPassword, retypePassword)
    if (validationResponse) {
      const response = await updatePassword({
        PolicyNumber: retrievedPolicyUser.User.Policy_Number,
        ZipCode: retrievedPolicyUser.User.Zip,
        NewPassword: newPassword
      })

      if (response === undefined) {
        const url = `/my-account/forgot-password`
        window.location = url
      }

      setPasswordResetMessage(response.data.Result)

      if (response.data.Result === 'Success') {
        setShowLogin(true)
      }
    }
    setShowSpinner(false)
  }

  const validateBasicInfo = () => {
    if (lastName.length === 0 || dateOfBirth.length === 0 || zipCode.length === 0 || zipCode.length < 5) {
      return true
    }
    if (new Date(dateOfBirth).toString() === 'Invalid Date') {
      return true
    }
    return false
  }

  const validateSecurityOption = () => {
    let response = false
    if (
      selectedResetOption === -1 ||
      selectedPwdOption === -1 ||
      !securityAnswer ||
      (securityAnswer && securityAnswer.length === 0)
    ) {
      response = true
    }
    if (selectedResetOption === 1) {
      response = false
    }

    return response
  }

  const validateConfirmPassword = () => {
    let response = false
    if (newPassword.length === 0 || retypePassword.length === 0) {
      response = true
    } else if (newPassword.length > 0 && retypePassword.length > 0) {
      if (newPassword === retypePassword) {
        const isValidLength = /^(?=.*[0-9])(?=.*[A-Z]).{5,}$/
        if (!isValidLength.test(newPassword)) {
          response = true
        } else {
          response = false
        }
      } else {
        response = true
      }
    }
    return response
  }

  const validatePassword = () => {
    const isValidLength = /^(?=.*[0-9])(?=.*[A-Z]).{5,}$/
    let response = false
    if (password.length === 0) {
      response = true
    } else if (password.length > 0) {
      if (!isValidLength.test(password)) {
        response = true
      } else {
        response = false
      }
    }
    return response
  }

  const loginWithCurrentEmail = async () => {
    setMessage(null)
    setShowSpinner(true)
    setLoginApiResponseMessage(null)
    const validationResponse = validatePassword()
    if (!validationResponse) {
      const emailAddress = retrievedPolicyUser.User.EmailAddress
      const response = await verifyLogin(emailAddress, password, 'login')
      if (response && response.data) {
        setPassword('')
        setPasswordResetMessage('')
        const { Result, Tkn } = response.data
        setLoginApiResponseMessage(Result)
        if (Result === 'Success') {
          const url = `https://${getDomain('account')}/home?tkn=${Tkn}`
          window.location = url
        }
      }
    } else {
      setLoginApiResponseMessage('Not Found')
      setShowSpinner(false)
    }
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter' && !validateBasicInfo()) {
      handleSubmit()
    }
  }

  const handleSecurityKeyDown = event => {
    if (event.key === 'Enter' && !validateSecurityOption()) {
      validateUser()
    }
  }

  const handleChangePasswordKeyDown = event => {
    if (event.key === 'Enter' && !validateConfirmPassword()) {
      handleUpdatePassword()
    }
  }

  const handleNewPasswordKeyDown = event => {
    if (event.key === 'Enter') {
      loginWithCurrentEmail()
    }
  }

  return (
    <>
      <SEO
        title={"Reset Password | CURE Auto Insurance"} 
        description={"Forgot your password? Reset your account login securely online."} 
        url={"/my-account/forgot-password"}
      />
      <EmptyHeaderHero title="Trouble Logging In?" />
      <div className={`${ForgotPassStyle["forgot-password-screen"]}`}>
        <Row>
          <Card className={`${ForgotPassStyle["forgot-password-card"]}`}>
            <div>
              {!retrievedPolicyUser && (
                <div>
                  <h5 className={`${ForgotPassStyle["sub-label"]}`}>Reset your password.</h5>
                  <Row>
                    <Col
                      className={`${ForgotPassStyle["account-margin"]}`}
                      lg={{ span: 6 }}
                      md={{ span: 8 }}
                      xl={{ span: 6 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item>
                        <Input
                          autoComplete="off"
                          className={`${ForgotPassStyle["input-text"]}`}
                          onChange={event => setLastName(event.target.value)}
                          onKeyDown={handleKeyDown}
                          placeholder="Last Name*"
                          value={lastName}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={`${ForgotPassStyle["account-margin"]}`}
                      lg={{ span: 6 }}
                      md={{ span: 8 }}
                      xl={{ span: 6 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item>
                        <InputMask
                          className={`${ForgotPassStyle["dob"]}`}
                          mask="99/99/9999"
                          onChange={event => setDateOfBirth(event.target.value)}
                          onKeyDown={handleKeyDown}
                          placeholder="DOB (mm/dd/yyyy)*"
                          value={dateOfBirth}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={`${ForgotPassStyle["account-margin"]}`}
                      lg={{ span: 6 }}
                      md={{ span: 8 }}
                      xl={{ span: 6 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item>
                        <Input
                          autoComplete="off"
                          className={`${ForgotPassStyle["input-text"]}`}
                          maxLength={5}
                          onChange={handleZipCodeChange}
                          onKeyDown={handleKeyDown}
                          placeholder="Zip Code*"
                          value={zipCode}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  {message && (
                    <Row className={`${ForgotPassStyle["margin-bottom-8"]}`}>
                      <Col
                        className={`${ForgotPassStyle["account-margin-select"]}`}
                        lg={{ span: 8 }}
                        md={{ span: 8 }}
                        xl={{ span: 8 }}
                        xs={{ span: 24 }}
                      >
                        {message === "No Account Found" && <Text className={`${ForgotPassStyle["error-msg"]}`}>Unable to locate policy.</Text>}
                        {message === 'Success' && <Text className={`${ForgotPassStyle["success-msg"]}`}>{message}</Text>}
                        {message === 'Inactive' && <Text className={`${ForgotPassStyle["error-msg"]}`}>
                          Your policy is inactive. Please call 800-535-2873 for assistance.
                        </Text>}
                        {!['Success', 'No Account Found', 'Inactive'].includes(message) && <Text className={`${ForgotPassStyle["error-msg"]}`}>{message}</Text>}
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col
                      className={`${ForgotPassStyle["account-margin"]}`}
                      lg={{ span: 6 }}
                      md={{ span: 8 }}
                      xl={{ span: 6 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item className={`${ForgotPassStyle["btn-control"]} ${ForgotPassStyle["text-center"]}`}>
                        <Button
                          className={`${ForgotPassStyle["submit"]} ${ForgotPassStyle["submit-form-button"]} ${ForgotPassStyle["desktop-width-128"]}`}
                          disabled={validateBasicInfo()}
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                        {showSpinner && <Spin indicator={antIcon} style={{marginLeft: '2rem'}}/>}
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
            {(retrievedPolicyUser != 0) && retrievedPolicyUser && !changePassword && tempPasswordMsg && (
              <div>
                <Text className={`${ForgotPassStyle["reset-success-msg"]}`}>
                  {tempPasswordMsg}
                </Text>
                <Button
                  className={`${ForgotPassStyle["submit"]} ${ForgotPassStyle["submit-form-button"]}`}
                  onClick={() => Router.push('/my-account')}
                  style={{ width: 'auto', padding: '0 24px' }}
                >
                  Log In
                </Button>
              </div>
            )}
            {retrievedPolicyUser && !changePassword && !tempPasswordMsg && (
              <div>
                <h5 className={`${ForgotPassStyle["sub-label"]}`}>Choose your password reset method.</h5>
                <Row>
                  <Col className={`${ForgotPassStyle["account-margin"]}`} xl={{ span: 24 }} xs={{ span: 24 }}>
                    <Radio.Group onChange={handleRadioButtonClick} value={selectedResetOption}>
                      <Space direction="vertical" size={16}>
                        <Radio value={1}>
                          Request a temporary password be sent to the email associated with your account.
                        </Radio>
                        <Radio value={2}>Answer one of your security questions.</Radio>
                      </Space>
                    </Radio.Group>
                  </Col>
                </Row>
                {selectedResetOption > 1 && (
                  <>
                    <Row className={`${ForgotPassStyle["security-questions"]}`}>
                      <Col className={`${ForgotPassStyle["account-margin"]}`} xl={{ span: 24 }} xs={{ span: 24 }}>
                        {filteredSecurityQuestions && (
                          <Radio.Group className="margin-top-8" onChange={handleRadioClick} value={selectedPwdOption}>
                            <Space direction="vertical">
                              {filteredSecurityQuestions.map(({ Code, Text }) => (
                                <Radio key={Code} value={Code}>
                                  {Text}
                                </Radio>
                              ))}
                            </Space>
                          </Radio.Group>
                        )}
                      </Col>
                      <Col className={`${ForgotPassStyle["account-margin"]}`} xl={{ span: 11 }} xs={{ span: 24 }}>
                        <Form.Item>
                          <Input
                            autoComplete="off"
                            className={`${ForgotPassStyle["input-text"]} ${ForgotPassStyle["desktop-width-410"]} ${ForgotPassStyle["margin-top-12"]}`}
                            onChange={event => setSecurityAnswer(event.target.value)}
                            onKeyDown={handleSecurityKeyDown}
                            placeholder="Answer..."
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}

                {securityQuestionMessage && (
                  <Row className={`${ForgotPassStyle["margin-bottom-8"]}`}>
                    <Col
                      className={`${ForgotPassStyle["account-margin-select"]}`}
                      lg={{ span: 8 }}
                      md={{ span: 8 }}
                      xl={{ span: 8 }}
                      xs={{ span: 24 }}
                    >
                      {securityQuestionMessage !== 'Success' && (
                        <Text className={`${ForgotPassStyle["error-msg"]}`}>{securityQuestionMessage}</Text>
                      )}
                    </Col>
                  </Row>
                )}
                <Row className={`${ForgotPassStyle["desktop-width-410"]} ${ForgotPassStyle["margin-left-0"]}`} justify="center">
                  <Col className={`${ForgotPassStyle["account-margin"]} ${ForgotPassStyle["margin-top-12"]}`}>
                    <Form.Item className={`${ForgotPassStyle["btn-control"]}`}>
                      <Button
                        className={`${ForgotPassStyle["submit"]} ${ForgotPassStyle["submit-form-button"]} ${ForgotPassStyle["desktop-width-128"]}`}
                        disabled={validateSecurityOption()}
                        onClick={validateUser}
                      >
                        Submit
                      </Button>
                      {showSpinner && <Spin indicator={antIcon} style={{marginLeft: '2rem'}}/>}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )}
            {changePassword && !showLogin && (
              <div>
                <h5 className={`${ForgotPassStyle["sub-label"]}`}>Set your new password.</h5>
                {isMobile && (
                  <h4 className={`${ForgotPassStyle["sub-label"]} ${ForgotPassStyle["email"]}`}>
                    Your Username (Email):&nbsp;&nbsp;&nbsp;
                    <span>{retrievedPolicyUser.User.EmailAddress}</span>
                  </h4>
                )}
                {!isMobile && (
                  <h4 className={`${ForgotPassStyle["sub-label"]} ${ForgotPassStyle["email"]}`}>
                    Your Username (Email): <span>{retrievedPolicyUser.User.EmailAddress}</span>
                  </h4>
                )}
                <h4 className={`${ForgotPassStyle["sub-label"]} ${ForgotPassStyle["email"]}`}>
                  Passwords must have at least 5 characters with 1 number and 1 capital letter.
                </h4>
                <Row>
                  <Col className={`${ForgotPassStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input.Password
                        autoComplete="off"
                        className={`${ForgotPassStyle["input-text"]}`}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onChange={event => setNewPassword(event.target.value)}
                        onKeyDown={handleChangePasswordKeyDown}
                        placeholder="Password*"
                        type="password"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col className={`${ForgotPassStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input.Password
                        autoComplete="off"
                        className={`${ForgotPassStyle["input-text"]}`}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onChange={event => setRetypePassword(event.target.value)}
                        onKeyDown={handleChangePasswordKeyDown}
                        placeholder="Confirm Password*"
                        type="password"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {passwordResetMessage && (
                  <Row className={`${ForgotPassStyle["margin-bottom-8"]}`}>
                    <Col
                      className={`${ForgotPassStyle["account-margin-select"]}`}
                      lg={{ span: 8 }}
                      md={{ span: 8 }}
                      xl={{ span: 8 }}
                      xs={{ span: 24 }}
                    >
                      {passwordResetMessage !== 'Success' && <Text className={`${ForgotPassStyle["error-msg"]}`}>{passwordResetMessage}</Text>}
                      {passwordResetMessage === 'Success' && (
                        <Text className={`${ForgotPassStyle["success-msg"]}`}>Thank you. You have successfully changed your password.</Text>
                      )}
                    </Col>
                  </Row>
                )}
                <Row className={`${ForgotPassStyle["desktop-380"]}`} justify="center">
                  <Col className={`${ForgotPassStyle["account-margin"]}`}>
                    <Form.Item className={`${ForgotPassStyle["btn-control"]}`}>
                        <Button
                          className={`${ForgotPassStyle["submit"]} ${ForgotPassStyle["submit-form-button"]} ${ForgotPassStyle["desktop-width-128"]}`}
                          disabled={validateConfirmPassword()}
                          onClick={handleUpdatePassword}
                        >
                          Submit
                        </Button>
                        {showSpinner && <Spin indicator={antIcon} style={{marginLeft: '2rem'}}/>}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )}
            {changePassword && showLogin && (
              <div>
                <h5 className={`${ForgotPassStyle["sub-label"]}`}>Log in with your new password.</h5>
                {isMobile && (
                  <h4 className={`${ForgotPassStyle["sub-label"]} ${ForgotPassStyle["email"]}`}>
                    Your Username (Email):&nbsp;&nbsp;&nbsp;
                    <span>{retrievedPolicyUser.User.EmailAddress}</span>
                  </h4>
                )}
                {!isMobile && (
                  <h4 className={`${ForgotPassStyle["sub-label"]} ${ForgotPassStyle["email"]}`}>
                    Your Username (Email): <span>{retrievedPolicyUser.User.EmailAddress}</span>
                  </h4>
                )}
                {passwordResetMessage === 'Success' && (
                  <Text className={`${ForgotPassStyle["success-msg"]} ${ForgotPassStyle["margin-bottom-12"]}`}>
                    Thank you. You have successfully changed your password.
                  </Text>
                )}
                <Row>
                  <Col className={`${ForgotPassStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input
                        autoComplete="off"
                        className={`${ForgotPassStyle["input-text"]} ${ForgotPassStyle["dark-text"]}`}
                        disabled
                        onKeyDown={handleNewPasswordKeyDown}
                        placeholder="Email Address"
                        value={retrievedPolicyUser.User.EmailAddress}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col className={`${ForgotPassStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input.Password
                        autoComplete="off"
                        className={`${ForgotPassStyle["input-text"]}`}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onChange={event => setPassword(event.target.value)}
                        onKeyDown={handleNewPasswordKeyDown}
                        placeholder="Password*"
                        type="password"
                        value={password}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {loginApiResponseMessage === 'Not Found' && (
                  <Text className={`${ForgotPassStyle["error-msg"]}`}>Invalid email address or password.</Text>
                )}
                <Row className={`${ForgotPassStyle["desktop-380"]}`}>
                  <Col className={`${ForgotPassStyle["account-margin"]}`} style={{ width: '100%', textAlign: 'center' }}>
                    <Form.Item className={`${ForgotPassStyle["btn-control"]}`}>
                      <Button className={`${ForgotPassStyle["submit"]} ${ForgotPassStyle["submit-form-button"]} ${ForgotPassStyle["desktop-width-128"]}`} onClick={loginWithCurrentEmail}>
                        Log In
                      </Button>
                      {showSpinner && <Spin indicator={antIcon} style={{marginLeft: '2rem'}}/>}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )}
          </Card>
        </Row>
      </div>
    </>
  )
}

ForgotPassword.propTypes = {}

export default ForgotPassword
